import { render, staticRenderFns } from "./SvgLayered.vue?vue&type=template&id=252182a0&scoped=true"
import script from "./SvgLayered.vue?vue&type=script&lang=js"
export * from "./SvgLayered.vue?vue&type=script&lang=js"
import style0 from "./SvgLayered.vue?vue&type=style&index=0&id=252182a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252182a0",
  null
  
)

export default component.exports